import { PropsWithChildren, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './StateStatus.module.css';

export enum StatusType {
  OK = 'ok',
  WARNING = 'warning',
  ERROR = 'error',
  PENDING = 'pending',
  RUNNING = 'running',
  ABORTED = 'aborted',
}

type StatusProps = {
  type: StatusType;
  children: ReactNode;
};

export const StateStatus = ({ type, children }: StatusProps) => (
  <div className={styles.root}>
    <div className={classNames(styles.dot, styles[type])} />
    {children}
  </div>
);

// For backward compatibility, export the individual status components
export const StatusOK = ({ children }: PropsWithChildren) => (
  <StateStatus type={StatusType.OK}>{children}</StateStatus>
);

export const StatusWarning = ({ children }: PropsWithChildren) => (
  <StateStatus type={StatusType.WARNING}>{children}</StateStatus>
);

export const StatusError = ({ children }: PropsWithChildren) => (
  <StateStatus type={StatusType.ERROR}>{children}</StateStatus>
);

export const StatusPending = ({ children }: PropsWithChildren) => (
  <StateStatus type={StatusType.PENDING}>{children}</StateStatus>
);

export const StatusRunning = ({ children }: PropsWithChildren) => (
  <StateStatus type={StatusType.RUNNING}>{children}</StateStatus>
);

export const StatusAborted = ({ children }: PropsWithChildren) => (
  <StateStatus type={StatusType.ABORTED}>{children}</StateStatus>
);
